import { useState, useContext, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Button,
  Dialog,
  TextField,
  Typography,
  DialogContent,
  FormHelperText,
  MenuItem,
  Select,
  FormControl
} from "@mui/material";
import { useMutation } from "@apollo/client";
import "../../Style/dialogstyle.scss";
import { SelectWorkGroup, SelectVillage, SelectCommune } from "../Include/DynamicSelect";
import { AuthContext } from "../../Context/AuthContext";
import { DialogTitleComp } from "../../Utils/Component";
// import { useGetNextNumberingOfWorkGroup } from "../../Hooks/useGetNextNumberingOfWorkGroup";
import { CREATE_QUESTION_AND_ANSWER, UPDATE_QUESTION_AND_ANSWER } from "../../Schema/PublicForum";

export default function QuestionAndAnswerForm({
  open,
  editData,
  publicForumData,
  setRefetch,
  handleClose,
  dialogTitle,
}) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createQuestionAnswerPublicForum] = useMutation(CREATE_QUESTION_AND_ANSWER, {
    onCompleted: ({ createQuestionAnswerPublicForum }) => {
      setLoading(false);
      if (createQuestionAnswerPublicForum?.isSuccess === true) {
        setAlert(true, "success", createQuestionAnswerPublicForum?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createQuestionAnswerPublicForum?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateQuestionAnswerPublicForum] = useMutation(UPDATE_QUESTION_AND_ANSWER, {
    onCompleted: ({ updateQuestionAnswerPublicForum }) => {
      setLoading(false);
      if (updateQuestionAnswerPublicForum?.isSuccess === true) {

        setAlert(true, "success", updateQuestionAnswerPublicForum?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateQuestionAnswerPublicForum?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    workGroupId: Yup.object().shape({
      id: Yup.string(),
      title: Yup.string()
    }),
    questionType: Yup.string(),
    asker: Yup.string(),
    communeSangkatId: Yup.object().shape({
      id: Yup.string(),
      title: Yup.string()
    }),
    villageId: Yup.object().shape({
      id: Yup.string(),
      title: Yup.string()
    }),
    question: Yup.string().required(true),
    answer: Yup.string(),
    conclusion: Yup.string()
  });

  const formik = useFormik({
    initialValues: {
      workGroupId: { id: "", title: "" },
      questionType: "oral_questions",
      asker: "",
      communeSangkatId: { id: "", title: "" },
      villageId: { id: "", title: "" },
      question: "",
      answer: "",
      conclusion: "follow_up"

    },

    validationSchema: CheckValidation,

    onSubmit: async (values) => {
      setLoading(true);
      const createInputData = {
        publicForumId: publicForumData?._id,
        workGroupId: values?.workGroupId?.id || null,
        questionType: values?.questionType,
        asker: values?.asker,
        communeSangkatId: values?.communeSangkatId?.id || null,
        villageId: values?.villageId?.id || null,
        question: values?.question,
        answer: values?.answer,
        conclusion: values?.conclusion
      }
      const updateInputData = {
        workGroupId: values?.workGroupId?.id || null,
        questionType: values?.questionType,
        asker: values?.asker,
        communeSangkatId: values?.communeSangkatId?.id || null,
        villageId: values?.villageId?.id || null,
        question: values?.question,
        answer: values?.answer,
        conclusion: values?.conclusion
      }

      if (dialogTitle === "Update") {

        updateQuestionAnswerPublicForum({
          variables: {
            id: editData?._id,
            input: updateInputData,
          },
        });
      } else {

        createQuestionAnswerPublicForum({
          variables: {
            input: createInputData,
          },
        });
      }
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    resetForm,
  } = formik;


  useEffect(() => {
    if (editData) {
      if (editData?.workGroupId?._id) {
        setFieldValue("workGroupId", { id: editData?.workGroupId?._id, title: editData?.workGroupId?.numbering + ". " + editData?.workGroupId?.work_group_name })
      } else {
        setFieldValue("workGroupId", { id: "", title: "" })
      }
      setFieldValue("questionType", editData?.questionType)
      setFieldValue("asker", editData?.asker);
      setFieldValue("question", editData?.question);
      setFieldValue("answer", editData?.answer);
      setFieldValue("conclusion", editData?.conclusion)
      setFieldValue("communeSangkatId", {
        id: editData?.communeSangkatId?._id || "",
        title: editData?.communeSangkatId?.commune_sangkat_name_kh || "",
      });
      setFieldValue("villageId", {
        id: editData?.villageId?._id || "",
        title: editData?.villageId?.village_name_kh || "",
      });


    }
  }, [editData, open]);
  // console.log(publicForumData, "publicForumData");
  // console.log(editData, "editData");
  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm" fullWidth>
      <DialogTitleComp
        title={
          dialogTitle === "Create"
            ? t("modal_title_create_question_and_answer")
            : t("modal_title_update_question_and_answer")
        }
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers >
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2.5} columnSpacing={1}>
              <Grid item xs={12} md={7.5}>
                <Typography className={t("class-name-field-title")}>
                  {t('select_work_group')}
                </Typography>
                <SelectWorkGroup
                  onChange={(val) => setFieldValue("workGroupId", val || { id: "", title: "" })}
                  valueSelected={values?.workGroupId}
                  error={Boolean(
                    touched.workGroupId?.id && errors.workGroupId?.id
                  )}
                  helperText={touched.workGroupId?.id && errors.workGroupId?.id}
                  required={false}
                />
              </Grid>
              <Grid item xs={12} md={4.5}>
                <Typography className={t("class-name-field-title")}>
                  {t('question_type')}
                </Typography>
                <FormControl fullWidth className="search-field" size="small">
                  <Select
                    value={values?.questionType}
                    onChange={(e) => setFieldValue("questionType", e?.target.value)}
                  >
                    <MenuItem value={"oral_questions"}>{t("oral_questions")}</MenuItem>
                    <MenuItem value={"written_questions"}>{t("written_questions")}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4} >
                <Typography className={t("class-name-field-title")}>
                  {t("thead_asker")}
                </Typography>
                <TextField
                  className="text-field"
                  size="small"
                  fullWidth
                  placeholder={t("thead_asker")}
                  {...getFieldProps("asker")}
                  error={Boolean(touched.asker && errors.asker)}
                  helperText={touched.asker && errors.asker}
                />
              </Grid>

              <Grid item xs={4} >
                <Typography className={t("class-name-field-title")}>
                  {t("thead_commune_sangkat")}
                </Typography>
                <SelectCommune
                  districtMunicipalitiesId={
                    publicForumData?.districtMunicipalityId?._id || ""
                  }
                  value={values?.communeSangkatId}
                  onChange={(val) => {
                    setFieldValue("communeSangkatId", val || "");
                    setFieldValue("villageId", {
                      id: "",
                      title: "",
                    });
                  }}
                  helperText={
                    touched.communeSangkatId?.id &&
                    errors.communeSangkatId?.id
                  }
                  error={Boolean(
                    touched.communeSangkatId?.id &&
                    errors.communeSangkatId?.id
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_village")}
                </Typography>
                <SelectVillage
                  communeSangkatId={
                    values?.villageId?.id || ""
                  }
                  value={values?.villageId}
                  onChange={(val) => {
                    setFieldValue("villageId", val || "");
                  }}
                  helperText={
                    touched.villageId?.id &&
                    errors.villageId?.id
                  }
                  error={Boolean(
                    touched.villageId?.id &&
                    errors.villageId?.id
                  )}
                />
              </Grid>
              <Grid item xs={12} >
                <Typography className={t("class-name-field-title")}>
                  {t("thead_question_or_suggestion")}
                </Typography>
                <TextField
                  className="text-field"
                  size="small"
                  fullWidth
                  placeholder={t("thead_question_or_suggestion")}
                  {...getFieldProps("question")}
                  error={Boolean(touched.question && errors.question)}
                  helperText={touched.question && errors.question}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_answer")}
                </Typography>
                <TextField
                  className="text-field"
                  multiline
                  rows={7}
                  size="small"
                  fullWidth
                  placeholder={t("thead_answer")}
                  {...getFieldProps("answer")}
                  error={Boolean(touched.answer && errors.answer)}
                  helperText={touched.answer && errors.answer}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className={t("class-name-field-title")}>
                  {t('conclusion')}
                </Typography>
                <FormControl fullWidth className="search-field" size="small">
                  <Select
                    value={values?.conclusion}
                    onChange={(e) => setFieldValue("conclusion", e?.target.value)}
                  >
                    <MenuItem value={"follow_up"}>{t("follow_up")}</MenuItem>
                    <MenuItem value={"completed"}>{t("completed")}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className={t("class-btn-create")}
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {dialogTitle === "Update" ? t("update") : t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
